var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row" }, [
        _c("h2", { staticClass: "col-12" }, [
          _vm._v(_vm._s(_vm.$t("Feedback.Ready")))
        ])
      ]),
      _vm._v(" "),
      _c(
        "text-label-control",
        {
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function() {
                return [_c("b", [_vm._v(_vm._s(_vm.$t("OrganisationName")))])]
              },
              proxy: true
            }
          ])
        },
        [_vm._v(" "), [_vm._v(_vm._s(_vm.organisationName))]],
        2
      ),
      _vm._v(" "),
      _c(
        "text-label-control",
        {
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function() {
                return [
                  _c("b", [_vm._v(_vm._s(_vm.$t("Pdf.OrganisationNumber")))])
                ]
              },
              proxy: true
            }
          ])
        },
        [_vm._v(" "), [_vm._v(_vm._s(_vm.organisationNumber))]],
        2
      ),
      _vm._v(" "),
      _vm.model.record.aidTargetNumber
        ? _c(
            "text-label-control",
            {
              scopedSlots: _vm._u(
                [
                  {
                    key: "label",
                    fn: function() {
                      return [
                        _c("b", [_vm._v(_vm._s(_vm.$t("AidTargetNumber")))])
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                811736684
              )
            },
            [_vm._v(" "), [_vm._v(_vm._s(_vm.model.record.aidTargetNumber))]],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "text-label-control",
        {
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function() {
                return [_c("b", [_vm._v(_vm._s(_vm.$t("Purpose")))])]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          [
            _c("span", {
              staticClass: "preformatted",
              domProps: { innerHTML: _vm._s(_vm.model.purpose) }
            })
          ]
        ],
        2
      ),
      _vm._v(" "),
      _vm.model.approvalDate
        ? _c(
            "text-label-control",
            {
              scopedSlots: _vm._u(
                [
                  {
                    key: "label",
                    fn: function() {
                      return [
                        _c("b", [
                          _vm._v(_vm._s(_vm.$t("Feedback.ApprovalDate")))
                        ])
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                2913047462
              )
            },
            [
              _vm._v(" "),
              [
                _vm._v(
                  _vm._s(
                    _vm._f("formatDatetime")(_vm.model.approvalDate, "D.M.YYYY")
                  )
                )
              ]
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "text-label-control",
        {
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function() {
                return [_c("b", [_vm._v(_vm._s(_vm.$t("Feedback.State")))])]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          [
            _vm._v(
              _vm._s(
                _vm.$t("Enums.DecisionState." + _vm.model.record.decisionState)
              )
            )
          ]
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "text-label-control",
        {
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function() {
                return [_c("b", [_vm._v(_vm._s(_vm.$t("Feedback.Feedback")))])]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          [
            _c("span", {
              staticClass: "preformatted",
              domProps: { innerHTML: _vm._s(_vm.model.record.feedback) }
            })
          ]
        ],
        2
      ),
      _vm._v(" "),
      _vm.model.showDecisionMaker
        ? _c(
            "text-label-control",
            {
              scopedSlots: _vm._u(
                [
                  {
                    key: "label",
                    fn: function() {
                      return [
                        _c("b", [
                          _vm._v(_vm._s(_vm.$t("Feedback.DecisionMaker")))
                        ])
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                392680949
              )
            },
            [
              _vm._v(" "),
              [_vm._v(_vm._s(_vm.model.record.decisionMaker.contactInfo))]
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }